export const config = {
	candidateBase: "https://candidate.hire3x.com/builder",
	websiteBase: "https://hire3x.com/",
	trainingBase: "https://candidate.hire3x.com/training",
	recruitmentBase: "https://recruitment.hire3x.com",
	assessmentBase: "https://judge.hire3x.com",
	trainingAdminBase: "https://trainingadmin.hire3x.com",
};
